import { useI18n } from 'vue-i18n'

export const checkI18n = (key: string, variable?: any) => {
  const { t, te } = useI18n()

  if (te(`v1.0.${key}`)) return t(`v1.0.${key}`, variable)
  else return t(key, variable)
}
